import cx                                     from 'classnames';
import React, { PropTypes }                   from 'react';
import { get }                                from 'lodash';
import VideoActions                           from 'actions/video_actions';
import TrackingActions                        from 'actions/tracking_actions';
import { Link }                               from 'react-router';
import { isLocal, getImageServer, envCheck }  from 'utils/util';
import HasPrettyTime                          from 'mixins/has_pretty_time';

export default React.createClass({
  displayName: 'Player.PlaylistItem',
  propTypes: {
        onClick: PropTypes.func,
     isSelected: PropTypes.bool,
          video: PropTypes.object,
          index: PropTypes.number,
      hasViewed: PropTypes.bool,
       duration: PropTypes.number,
        enabled: PropTypes.bool
  },
  mixins: [HasPrettyTime],
  selectVideo(e) {
    if(this.props.enabled === false) {
      return;
    }
    e.preventDefault();
    if(!this.props.isSelected) {
      if(this.props.onClick) {
        this.props.onClick(e);
      }
      VideoActions.selectVideo(this.props.video, this.props.index);
    }
  },
  track() {
    if(!this.props.video.isAdvertisement) {
      TrackingActions.selectVideo(`vidmtv-show_${get(this, 'props.video.videoIndex', 0) + 1 }`);
    } else {
      TrackingActions.selectVideo(`vidmtv-show_ifi`);
    }
  },
  render() {
    let title = null;
    if(this.props.video.isAdvertisement) {
      title = (<div className="advertisment">INFORMATION FROM INDUSTRY</div>);
      if(this.props.isSelected === true) {
        const trackingAnchorContainer = document.createElement('div');
        const trackingPixelHTML = get(this, 'props.video.trackingPixelHTML', '');
        trackingAnchorContainer.innerHTML = trackingPixelHTML;
        document.body.appendChild(trackingAnchorContainer);
      }
    } else {
      if(this.props.video.videoTag !== '') {
        title = (<div className="low-light">{this.props.video.videoTag}</div>);
      } else if(this.props.video.isIndexed === true) {
        title = (<div className="low-light"> {`Episode ${get(this, 'props.video.videoIndex', 0) + 1 }   |   `} {this.secondsToPrettyTime(this.props.video.duration, 2)}</div>);
      }
    }
    if(this.props.isSelected === true) {
      document.getElementById('livefyre_iframe').setAttribute('src', `http://www${envCheck()}.medscape.com/mtv/${window.MedscapeTVInstance.seriesUrlFragment}/mtvc-${this.props.video.videoUrlFragment}`);
    }
    const classNames = cx({
      'video-player-playlist-item': true,
                     'is-selected': this.props.isSelected,
                      'has-viewed': this.props.hasViewed
    }),
    basePath = isLocal()? '': `/mtv/${window.MedscapeTVInstance.seriesUrlFragment}`,
    content = (<div className="video-title">
                  { title }
                  <div>{this.props.video.title}</div>
              </div>);
    let legend = null;
    if(this.props.hasViewed) {
      legend = <div className="watched">WATCHED</div>;
    }
    if(this.props.isSelected) {
      legend = <div className="now-playing">NOW PLAYING</div>;
    }
    return (
        <Link className={ classNames } onClick={this.track} to={`${basePath}/${this.props.video.videoUrlFragment}`}>
          <img className="thumbnail-btn" src={`${getImageServer()}/${this.props.video.thumbnail}`} />
          <img className="hover-btn" src={`${getImageServer()}/pi/core/medscapetv/assets/images/video-player/play-overlay.svg`} />
          { legend }
          { content }
        </Link>
    );
  }
});



/** WEBPACK FOOTER **
 ** ./modules/components/player/playlist_item.jsx
 **/